import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ChangePositionBtn from './components/ChangePositionBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import CategorySelect from './components/CategorySelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import SubCategoryIsHiddenCheckBox from './components/SubCategoryIsHiddenCheckBox';
import WithURLFilters from './components/WithURLFilters';
import style from './SubCategoryControlPanel.module.scss';

const SubCategoryControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.filteringControls}>
					<div className={style.selectWrapper}>
						<CustomerSelect />
						<RestaurantSelect />
						<CategorySelect />
					</div>
					<div className={style.subCategoryIsHiddenCheckBoxWrapper}>
						<SubCategoryIsHiddenCheckBox />
					</div>
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default SubCategoryControlPanel;
